module.exports = __webpack_public_path__ + "static/mysql-49528c1451c1041cf4216b332011682b.svg";